import styled from 'styled-components';

export const Header = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #252733;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  color: #525a67;

  .MuiSvgIcon-root {
    font-size: 18px;
  }
  
  .MuiIconButton-root {
    padding: 6px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  min-height: 234px;

  &.error {
    color: ${({ theme }) => theme.branding.tertiary.dark};
  }

  h4 {
    margin: 5px 0;
    font-weight: 600;
  }

  .MuiSkeleton-root {
    width: 100%;
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: #777777;
    margin: auto;

    span {
      font-size: 15px;
      font-weight: 600;
    }

    .MuiSvgIcon-root {
      font-size: 3.5rem;
    }
  }

  img {
    height: 200px;
    object-fit: contain;
  }

  video {
    max-width: 100%;
  }
`;

export const UploadBtn = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 10px;
  border-radius: 4px;
  background-color: #4573ff;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  font-weight: 600;
  cursor: pointer;
`;
